import Button from 'components/Buttons/Button';
import styled from 'styled-components';

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  text-align: left;
`;

export const TooltipTitle = styled.span`
  display: block;
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.255px;
  color: ${({ theme }) => theme.color.pickledBluewood};
  text-wrap: balance;
`;

export const TooltipMeta = styled.span`
  display: block;
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.color.baliHai};
  text-wrap: balance;
`;

export const TooltipCta = styled(Button)`
  width: 100%;
  max-width: 100%;
  height: 44px;
  min-height: 44px;
  box-sizing: border-box;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-transform: none;
`;

export const TooltipHint = styled.span`
  display: block;
  font-weight: 500;
  font-size: 11px;
  line-height: 14px;
  color: ${({ theme }) => theme.color.brightTurquoise};
`;

export const TooltipStatus = styled.span<{ $tone?: 'warning' | 'muted' }>`
  display: block;
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  color: ${({ theme, $tone }) =>
    $tone === 'warning' ? theme.color.koromiko : theme.color.casper};
`;
